import { types as t, Instance } from 'mobx-state-tree';
import WidgetModel from '~/mst/models/widget';
import Layout from '~/mst/models/widget/layout';
import i18n from '~/utils/i18n';
import DefaultLayout from './layout';

export const options = [
  { value: 'pie_chart', label: i18n.t('widgets.total_devices') },
  { value: 'column_chart', label: i18n.t('widgets.total_devices_by_type') }
];

const TotalDevicesWidgetModel = t
  .compose(
    WidgetModel,
    t.model({
      type: 'TotalDevicesOnlineWidget',
      chart_type: t.enumeration(
        'CharType',
        options.map(({ value }) => value)
      ),
      data: t.maybeNull(t.frozen()),
      layout: t.optional(Layout, DefaultLayout)
    })
  )
  .named('TotalDevicesOnlineWidget');

export interface ITotalDevicesWidgetModel extends Instance<typeof TotalDevicesWidgetModel> {}

export default TotalDevicesWidgetModel;
